import type { FaireAdPerformancePeriodEntity } from "../../entity_types/adPerformancePeriod";

export const perfP9BudgetCappedOvw202512: FaireAdPerformancePeriodEntity = {
  token: "perf_p9_budget_capped_ovw_202512",
  type: "adPerformancePeriod",
  scope: "OVERVIEW",
  periodType: "RECEIPT",
  startDate: "2025-12-01",
  endDate: "2025-12-31",
  impressions: 35583,
  clicks: 638,
  adsSpendDollars: 1845,
  budgetDollars: 4900,
  salesDollars: 10741,
  bestEstimateRoas: 5.82,
  bestEstimateType: "ACTUALIZED",
  budgetUtilization: 0.38,
  newCustomersAcquired: 16,
  reorderConversions: 16,
  dataAvailableAtDate: "2026-01-04",
  meta: {
    source: "mock",
    importedAt: "2026-07-06T00:00:00.000Z",
    importedBy: "advertiser-profiles",
  },
};
